module.exports = __webpack_public_path__ + "img/AppsyPretty1-1040x500.7752d773.jpg";